import React from "react";
import { cn } from "../../../helpers/classNames";
import { MenuItem } from "./Item";
import styles from "./content.module.scss";
import type { MenuItemType } from "./types";

type Props = {
    items: Array<MenuItemType>;
    closeMenu: () => void;
    isSSR?: boolean;
};

export const MenuContent: React.FC<Props> = ({
    items,
    closeMenu,
    isSSR = false,
}) => {
    return (
        <div className={cn(styles.wrapper, isSSR && styles.hidden)} role="menu">
            {items.map((item) => (
                <MenuItem
                    item={item}
                    key={`item-container-${item.title}`}
                    nestingLevel={0}
                    closeMenu={closeMenu}
                    isSSR={isSSR}
                />
            ))}
        </div>
    );
};
